module.exports = __webpack_public_path__ + "static/media/display-3.f7e753b9.png";